import { ValueType } from '@srm/ui/types/ValueType';

/**
 * Определяет, должен ли быть включён Header Filter для колонки по её типу данных.
 *
 * @param {ValueType} dataType - Тип значения поля (enum).
 * @returns {boolean} True, если Header Filter должен быть включён; иначе false.
 */
export const getColumnHeaderFilterStateByFieldDataType = (dataType: ValueType) => {
    switch (dataType) {
        case ValueType.Date:
        case ValueType.DateTime:
        case ValueType.NoSecDateTime:
        case ValueType.Time:
        case ValueType.Boolean:
            return false;
        default:
            return true;
    }
};
